module.exports = __webpack_public_path__ + "813ad36ab19a439b11649f5a81e01ab6.svg";